// extracted by mini-css-extract-plugin
export default {"wrapper_Table":"TableReportStatusKiz_wrapper_Table__sZS6i","table":"TableReportStatusKiz_table__ygn3f"};